import { render, staticRenderFns } from "./MobileProfile.vue?vue&type=template&id=1058f1de&"
import script from "./MobileProfile.vue?vue&type=script&lang=js&"
export * from "./MobileProfile.vue?vue&type=script&lang=js&"
import style0 from "./MobileProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports